import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {TableCardHeaderActionDefinitions} from '@aviary/components/table-card/table-card-header-actions/table-card-header-action.types';
import {ActionButtonsComponent} from '@aviary/components/action-buttons/action-buttons.component';
import {
  TableCardHeaderActionComponent
} from '@aviary/components/table-card/table-card-header-actions/table-card-header-action/table-card-header-action.component';

@Component({
  selector: 'mx-table-card-header-actions',
  template: `
    <mx-action-buttons>
      @for (definition of definitions; track definition.label) {
        <mx-table-card-header-action [definition]="definition"/>
      }
    </mx-action-buttons>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ActionButtonsComponent, TableCardHeaderActionComponent]
})
export class TableCardHeaderActionsComponent {

  @Input() public definitions: TableCardHeaderActionDefinitions = [];
}
